import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../internal/cx';
import styles from './PageHeader.module.css';

export interface PageHeaderProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  /** Page title, rendered as the page's single <h1>. */
  title: ReactNode;
  description?: ReactNode;
  /** Usually a <Breadcrumbs />. */
  breadcrumbs?: ReactNode;
  /** Primary page actions (buttons, menus), right-aligned on wide screens. */
  actions?: ReactNode;
  /** Inline metadata next to the title (e.g. status badges). */
  meta?: ReactNode;
  /** Tabs or TabNav rendered below the header. */
  tabs?: ReactNode;
}

export function PageHeader({
  title,
  description,
  breadcrumbs,
  actions,
  meta,
  tabs,
  className,
  ...rest
}: PageHeaderProps) {
  return (
    <header className={cx(styles.header, tabs != null && styles.withTabs, className)} {...rest}>
      {breadcrumbs && <div className={styles.breadcrumbs}>{breadcrumbs}</div>}
      <div className={styles.row}>
        <div className={styles.headings}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>{title}</h1>
            {meta && <div className={styles.meta}>{meta}</div>}
          </div>
          {description && <p className={styles.description}>{description}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {tabs && <div className={styles.tabs}>{tabs}</div>}
    </header>
  );
}
